(() => {
const init = (root) => {
if (root.dataset.gdInitialized) return;
root.dataset.gdInitialized = 'true';
const radios = [...root.querySelectorAll('[data-gd-profile]')];
const fields = root.querySelector('[data-gd-pro-fields]');
const subject = root.querySelector('#gd-contact-subject');
const company = root.querySelector('#gd-contact-company');
const setProfile = (professional) => {
fields.hidden = !professional;
fields.querySelectorAll('input,select,textarea').forEach(el => { el.disabled = !professional; });
fields.querySelectorAll('[data-gd-pro-required]').forEach(el => { el.required = professional; });
if (professional) subject.value = 'pro_subject';
else if (subject.value === 'pro_subject') subject.value = '';
};
radios.forEach(r => r.addEventListener('change', () => setProfile(r.dataset.gdProfile === 'professional')));
root.querySelector('[data-gd-pro-cta]').addEventListener('click', () => {
radios.find(r => r.dataset.gdProfile === 'professional').checked = true;
setProfile(true);
requestAnimationFrame(() => company.focus({preventScroll:true}));
});
subject.addEventListener('change', () => {
if (subject.value === 'pro_subject') {
radios.find(r => r.dataset.gdProfile === 'professional').checked = true;
setProfile(true);
}
});
setProfile(radios.some(r => r.checked && r.dataset.gdProfile === 'professional'));
root.querySelector('form').addEventListener('submit', () => {
try { sessionStorage.setItem('gd-contact-profile', radios.find(r => r.checked).dataset.gdProfile); } catch {}
});
if (location.search.includes('contact_posted') || root.querySelector('[role=alert]')) {
let isPro = false;
try { isPro = sessionStorage.getItem('gd-contact-profile') === 'professional'; } catch {}
radios.find(r => r.dataset.gdProfile === (isPro ? 'professional' : 'individual')).checked = true;
setProfile(isPro);
}
};
document.querySelectorAll('[data-gd-contact]').forEach(init);
document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-gd-contact]').forEach(init));
})();